import http from "./http";

export default {
  //上传图片
  uploadImg(params) {
    return http.post("common/attachment/uploadAtta", params);
  },

  // 授权微信jssdk
  getConfig(params) {
    return http.post("oil/h5/buildConfig", params);
  },
  // ----埋点相关----
  // 渠道二维码扫码记录
  channelScanRecordApi(params) {
    return http.post("oil/h5/code_scanning_record", params);
  },
  // 用户车型查询记录
  userQueryCarModelRecordApi(params) {
    return http.post("oil/h5/user_searching_record", params);
  },
  // ---- Token 相关 ----
  //获取当前是否有有效的Token，过期返回空（不同类型推荐详情）
  getValidTokenApi(params) {
    return http.get("oil/h5/get_token", params);
  },
  // 提交验证码
  submitVerificationCodeApi(params) {
    return http.post("oil/h5/check_captcha", params);
  },
  // 获取图片验证码
  submitVerificationCodeImgApi(params) {
    return http.get("oil/h5/get_captcha", params);
  },
  // 结合验证信息获取Token
  getTokenByVerificationInfoApi(params) {
    return http.post("oil/h5/get_new_token", params);
  },
};
